export const WEBCHAT_MINIMUM_FEE_GET_REQUESTED = 'WEBCHAT_MINIMUM_FEE_GET_REQUESTED';
export const WEBCHAT_MINIMUM_FEE_GET_SUCCEED = 'WEBCHAT_MINIMUM_FEE_GET_SUCCEED';
export const WEBCHAT_MINIMUM_FEE_GET_FAILED = 'WEBCHAT_MINIMUM_FEE_GET_FAILED';
